import { render, staticRenderFns } from "./editionOrganizers.vue?vue&type=template&id=fdf62c6a"
import script from "./editionOrganizers.vue?vue&type=script&lang=js"
export * from "./editionOrganizers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports